import { getPercentage } from 'utils/number';

import { KPI_KEYS } from 'components/config/rewardSystem';

export const getCoinsAccrued = (season) =>
  KPI_KEYS.reduce((acc, key) => {
    const { isDone, value } = season?.[key] ?? {};
    return isDone ? acc + (value ?? 0) : acc;
  }, 0);

export const getMarketingProgressValue = (marketingKPIResults) => {
  const totalCompleted = marketingKPIResults?.reduce(
    (acc, { marketingKPIStatus }) => acc + Number(marketingKPIStatus),
    0,
  );

  return getPercentage(totalCompleted, marketingKPIResults?.length);
};

export const getBusinessProgressValue = (
  businessKPIResults,
  businessKPIPlan,
) => {
  const totalValue = businessKPIResults?.reduce(
    (acc, { value }) => acc + value,
    0,
  );

  return getPercentage(totalValue, businessKPIPlan);
};

export const getAchievedKPI = (season, type, percentage) => {
  switch (type) {
    case 'marketing':
      return (
        getMarketingProgressValue(season.marketingKPIResults) >= percentage
      );
    case 'business':
      return (
        getBusinessProgressValue(
          season.businessKPIResults,
          season.businessKPIPlan,
        ) >= percentage
      );
    default:
      return false;
  }
};
